import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useVehicles } from '../../../hooks';
import styles from './InventoryList.module.css';

export const InventoryList: React.FC = () => {
  const { isLoading, loadVehicles, filteredVehicles, updateFilters, resetFilters } = useVehicles();

  const [searchTerm, setSearchTerm] = useState('');
  const [filterCondicion, setFilterCondicion] = useState<string>('todos');

  // Cargar vehículos y limpiar filtros al montar el componente
  useEffect(() => {
    loadVehicles();
    // Limpiar filtros para mostrar todos los vehículos al inicio
    resetFilters();
  }, [loadVehicles, resetFilters]);

  // Actualizar filtros cuando cambian
  useEffect(() => {
    const newFilters: any = {};

    // Si hay término de búsqueda, agregarlo
    if (searchTerm.trim()) {
      newFilters.searchTerm = searchTerm.trim();
    }

    // Si hay filtro de condición, agregarlo
    if (filterCondicion !== 'todos') {
      newFilters.condicion = filterCondicion;
    }

    // Actualizar filtros (si está vacío, se mostrarán todos los vehículos)
    updateFilters(newFilters);
  }, [searchTerm, filterCondicion, updateFilters]);

  if (isLoading) {
    return (
      <div className={styles.inventoryContainer}>
        <div className={styles.loading}>
          <div className={styles.spinner}></div>
          <p>Cargando vehículos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.inventoryContainer}>
      <div className={styles.header}>
        <div>
          <h1>Inventario de Vehículos</h1>
          <p>Gestiona el stock del concesionario</p>
        </div>
        <Link to="/inventory/add" className={styles.addButton}>
          ➕ Agregar Vehículo
        </Link>
      </div>

      <div className={styles.filters}>
        <input
          type="text"
          placeholder="🔍 Buscar por marca o modelo..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={styles.searchInput}
        />

        <select
          value={filterCondicion}
          onChange={(e) => setFilterCondicion(e.target.value)}
          className={styles.filterSelect}
        >
          <option value="todos">Todas las condiciones</option>
          <option value="nuevo">Nuevos</option>
          <option value="usado">Usados</option>
        </select>
      </div>

      {filteredVehicles.length > 0 ? (
        <div className={styles.vehicleGrid}>
          {filteredVehicles.map((vehicle) => (
            <Link
              key={vehicle.id}
              to={`/inventory/${vehicle.id}`}
              className={styles.vehicleCard}
            >
              <div className={styles.vehicleImage}>
                {vehicle.vehicleImageLink ? (
                  <img
                    src={vehicle.vehicleImageLink}
                    alt={`${vehicle.brand} ${vehicle.model}`}
                    className={styles.vehicleImageTag}
                    onError={(e) => {
                      // Si la imagen falla, mostrar icono por defecto
                      e.currentTarget.style.display = 'none';
                      const parent = e.currentTarget.parentElement;
                      if (parent) {
                        parent.textContent = vehicle.vehicleType === 'moto' ? '🏍️' : '🚗';
                      }
                    }}
                  />
                ) : (
                  vehicle.vehicleType === 'moto' ? '🏍️' : '🚗'
                )}
              </div>
              <div className={styles.vehicleInfo}>
                <div className={styles.vehicleHeader}>
                  <h3>{vehicle.brand} {vehicle.model}</h3>
                  <span className={`${styles.badge} ${styles[vehicle.condition]}`}>
                    {vehicle.condition === 'nuevo' ? 'Nuevo' : 'Usado'}
                  </span>
                </div>
                <div className={styles.vehicleDetails}>
                  <p><strong>Año:</strong> {vehicle.year}</p>
                  <p><strong>Color:</strong> {vehicle.color}</p>
                  <p><strong>Tipo:</strong> {vehicle.vehicleType}</p>
                </div>
                <div className={styles.vehicleFooter}>
                  <span className={styles.price}>
                    {vehicle.currency === 'USD' ? '$' : '$'}{vehicle.price.toLocaleString()} {vehicle.currency}
                  </span>
                  <span className={styles.viewDetails}>
                    Ver detalles →
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>📦</div>
          <h2>No hay vehículos en el inventario</h2>
          <p>Comienza agregando tu primer vehículo al sistema</p>
          <Link to="/inventory/add" className={styles.emptyButton}>
            ➕ Agregar Primer Vehículo
          </Link>
        </div>
      )}
    </div>
  );
};

